
import state from './moduleAuditTrialManagementState'
import mutations from './moduleAuditTrialManagementMutations'
import actions from './moduleAuditTrialManagementActions'
import getters from './moduleAuditTrialManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

